import React, { memo } from 'react'

import HowManyPoints from '../../../components/welcome/HowManyPoints'

const HowToEarnRewardsWrapper = ({ tokenSymbol }) => {
  return (
    <HowManyPoints
      data={[
        { i18nKey: 'brand:earn_rewards.label1', point: 20, tokenSymbol },
        {
          i18nKey: 'brand:earn_rewards.label2',
          number: 3,
          point: 50,
          tokenSymbol
        },
        {
          i18nKey: 'brand:earn_rewards.label3',
          number: 100,
          point: 50,
          tokenSymbol
        },
        {
          i18nKey: 'brand:earn_rewards.label2',
          number: 10,
          point: 50,
          tokenSymbol
        },
        {
          i18nKey: 'brand:earn_rewards.label5',
          number: '1’000',
          point: 50,
          tokenSymbol
        },
        {
          i18nKey: 'brand:earn_rewards.label5',
          number: '5’000',
          point: 100,
          tokenSymbol
        },
        {
          i18nKey: 'brand:earn_rewards.label5',
          number: '20’000',
          point: 200,
          tokenSymbol
        }
      ]}
    />
  )
}

export default memo(HowToEarnRewardsWrapper)
